import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import BookSeriesGroup from "components/BookGroup/groups/BookSeriesGroup";
import Divider from "components/ui/Divider";
import { PageSerializersBooksShow, SeriesSerializersBookSeriesGroup } from "types/serializers";

export default function BookSerieses({ book, bookSeries }: { book: PageSerializersBooksShow; bookSeries: SeriesSerializersBookSeriesGroup[] }) {
  if (!bookSeries || bookSeries.length === 0) {
    return <></>;
  }

  return (
    <Container size="md" variant="layout">
      <Heading level={2} size="md">
        Series
      </Heading>

      <div className="space-y-12 mt-4">
        {bookSeries.map((bs) => (
          <BookSeriesGroup
            key={`book-series-${bs.id}`}
            bookSeries={bs}
            activeBook={book}
            size={bs.featured ? "lg" : "md"}
          />
        ))}
      </div>
      <Divider size="lg" />
    </Container>
  );
}
